module.exports = __webpack_public_path__ + "assets/media/welcome.a4e8f08f.mp3";